import { Link } from "react-router-dom";

// Text-based logo + NL monogram. To replace with a real logo later,
// swap the markup inside <Link> only — no header restructure needed.
export const Logo = ({ light = true, compact = false }) => (
  <Link to="/" aria-label="New Lookz Hair Salon — home" data-testid="logo-link" className="inline-flex items-center gap-2.5 shrink-0">
    <span className="grid place-items-center w-9 h-9 rounded-md bg-copper text-ink font-display font-extrabold text-sm tracking-tight" aria-hidden="true">
      NL
    </span>
    {!compact && (
      <span className={`font-display font-extrabold tracking-[0.14em] text-base sm:text-lg ${light ? "text-white" : "text-ink"}`}>
        NEW&nbsp;LOOKZ
      </span>
    )}
  </Link>
);
